import Checklist from '@/classes/Checklist'
import LOOKBACK from './LOOKBACK'

export default {
  [LOOKBACK.service.id]: LOOKBACK
} as {[serviceId: string]: Checklist}
